import React, { useEffect, useMemo, useState } from "react";
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { isEmpty } from "lodash";
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";

//import components
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import PageHint from '../../../components/Common/PageHint';
import DeleteModal from '../../../components/Common/DeleteModal';
import LangModal from '../../../components/Common/LangModal';

import {
  addGallery as onAddGallery,
  updateGallery as onUpdateGalllery,
  getGallery as onGetGallery,
  deleteGallery as onDeleteGallery,

} from "store/contacts/actions";

import {
  Name,
  Status,
}
  from "./EcommerceOrderCol";
  import 'react-dropzone-uploader/dist/styles.css'
  import Dropzone from 'react-dropzone-uploader';

//redux
import { useSelector, useDispatch } from "react-redux";
import EcommerceOrdersModal from "./EcommerceOrdersModal";

import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
} from "reactstrap";
import { makeUploadParams } from "../../../helpers/imageResize";

function EcommerceOrder() {

  //meta title
  document.title = "Galeri | Buhara Baharat - Admin Paneli";
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const [getIsActive, setIsActive] = useState(false);
  // İşaretliyse kayıt sitedeki Kataloglar sayfasında, değilse Medya sayfasında görünür.
  const [getIsCatalog, setIsCatalog] = useState(false);
  const  [getFileNameMainPhoto, setFileNameMainPhoto] = useState(null);

  // Görseller sunucuya gitmeden önce tarayıcıda küçültülür (helpers/imageResize).
  const getUploadParams = makeUploadParams('https://buharaadmin.stechomeyazilim.info:8099/uploadfile');
   
  const  handleChangeStatusMainPhoto = ({ xhr }) => {
    if (xhr) {
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          const result = JSON.parse(xhr.response);
          setFileNameMainPhoto(result.file.filename)
        }
      }
    }
  }

  const handleChangeExtraPhoto = ({ file, meta, xhr }) => {
    if (xhr) {
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          try {
            const result = JSON.parse(xhr.response);
            const filename = result?.file?.filename;
  
            setUploadedFiles([
             
              {
                name: filename,
                type: file.type,
                url: filename // gerekirse URL'yi oluştur
              }
            ]);
          } catch (err) {
            console.error("Dosya parse hatası:", err);
          }
        }
      };
    }
  };
  

  const [modal, setModal] = useState(false);
  const [modal1, setModal1] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [orderList, setOrderList] = useState([]);
  const [order, setOrder] = useState(null);
  const [getEditSlider, setEditSlider] = useState(null);


  
  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      title: (getEditSlider && getEditSlider.Media_Tile) || '',
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Başlığı Giriniz"),
    }),
    onSubmit: (values) => {

      if (isEdit) {
        const updateSlider = {
          ID: order ? order.ID : 0,
          Media_Tile: values.title,
          Media_ImageCover: getFileNameMainPhoto,
          Media_IsActive: getIsActive,
          Media_IsCatalog: getIsCatalog,
          Media_Url: uploadedFiles.length > 0 ? uploadedFiles[0].url : null,
          Media_Type: uploadedFiles.length > 0 ? uploadedFiles[0].type : null,

        };
        // update order
        console.log("şmsdşf",updateSlider)
        dispatch(onUpdateGalllery(updateSlider));
        validation.resetForm();

        toggle()
      } else {
        const newOrder = {
          Media_Tile:values["title"],
          Media_ImageCover: getFileNameMainPhoto,
          Media_IsActive: getIsActive,
          Media_IsCatalog: getIsCatalog,
          Media_Url: uploadedFiles.length > 0 ? uploadedFiles[0].url : null,
          Media_Type: uploadedFiles.length > 0 ? uploadedFiles[0].type : null,

        };
        // save new order
        dispatch(onAddGallery(newOrder));
        toggle()

      }
     
    },
  });



  const toggleViewModal = () => setModal1(!modal1);

  const dispatch = useDispatch();
  const { orders } = useSelector(state => ({
    orders: state.contacts.gallery,
  }));

  useEffect(() => {
   if (orders && !orders.length) {
      dispatch(onGetGallery());
    }
  }, [dispatch, orders]);

  useEffect(() => {
    setOrderList(orders);
  }, [orders]);

  useEffect(() => {
    if (!isEmpty(orders) && !!isEdit) {
      setOrderList(orders);
      setIsEdit(false);
    }
  }, [orders]);

  const toggle = () => {
    if (modal) {
      setModal(false);
      setOrder(null);
    } else {
      setModal(true);
    }
  };

  const handleOrderClick = arg => {
    const order = arg;
    setEditSlider(order)
    setOrder(order);
    setIsEdit(true);
    setIsActive(order.Media_IsActive)
    setIsCatalog(!!order.Media_IsCatalog)
    setFileNameMainPhoto(order.Media_ImageCover)

    setUploadedFiles([
      
      {
        name: order.Media_Url,
        type: order.Media_Type,
        url: order.Media_Url,
      }
    ]);

    toggle();
  };

  //delete order
  const [deleteModal, setDeleteModal] = useState(false);
  const [langModal, setLangModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const onClickDelete = (order) => {
    setOrder(order);
    setDeleteModal(true);
  };

  const handleDeleteOrder = () => {
    if (order && order.ID) {
      dispatch(onDeleteGallery(order.ID));
      setDeleteModal(false);
    }
  };

  const handleOrderClicks = () => {
    setOrderList("");
    setIsEdit(false);
    setIsCatalog(false);
    setIsActive(false);
    setFileNameMainPhoto(null);
    setUploadedFiles([]);
    toggle();
  };

  const columns = useMemo(
    () => [
      {
        Header: 'BAŞLIK',
        accessor: 'Media_Tile',
        disableFilters: true,
        filterable: true,
        Cell: (cellProps) => {
          return <Name {...cellProps} />;
        }
      },
      {
        Header: "Ana Görsel",
        // accessor: "name",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps) => (
          <>
            {!cellProps.Media_ImageCover ? (
              <div className="avatar-xl">
               {cellProps.Media_Tile != null ? <span className="avatar-title rounded-circle">
                  {cellProps.Media_Tile.charAt(0)}
                </span> : null}
              </div>
            ) : (
              <div>
                <img
                  className=" avatar-xl"
                  src={'https://buharasubdomain.stechomeyazilim.info/' +  cellProps.Media_ImageCover}
                  alt=""
                />
              </div>
            )}
          </>
        ),
      },
  
      {
        Header: 'Ek Dosya',
        accessor: 'Media_Url',
        disableFilters: true,
        filterable: true,
        Cell: (cellProps) => {
          return <Name {...cellProps} />;
        }
      },

      {
        Header: 'Aktiflik Durumu',
        accessor: 'Media_IsActive',
        disableFilters: true,
        filterable: true,
        Cell: (cellProps) => {
          return <Status {...cellProps} />;
        }
      },
      {
        Header: 'İşlemler',
        accessor: 'action',
        disableFilters: true,
        Cell: (cellProps) => {
          return (
            <div className="d-flex gap-3">
              <Link
                to="#"
                className="text-success"
                onClick={() => {
                  const orderData = cellProps.row.original;
                  handleOrderClick(orderData);
                }}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Düzenle
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-info"
                onClick={() => {
                  setSelectedItem(cellProps.row.original);
                  setLangModal(true);
                }}
              >
                <i className="mdi mdi-translate font-size-18" id="langtooltip-gallery" />
                <UncontrolledTooltip placement="top" target="langtooltip-gallery">
                  Çeviriler
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-danger"
                onClick={() => {
                  const orderData = cellProps.row.original;
                  onClickDelete(orderData);
                }}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Sil
                </UncontrolledTooltip>
              </Link>
            </div>
          );
        }
      },
    ],
    []
  );

  const Preview = ({ meta }) => {
    const { name, percent, status, previewUrl } = meta;
    return (
      <div className="preview-box">
        <img src={previewUrl} /> <span className="name">{name}</span> - <span className="status">{status == "done" ? "Başarıyla Yüklendi" : "Yükleniyor"}</span>{status !== "done" && <span className="percent"> ({Math.round(percent)}%)</span>}
      </div>
    )
  }

  return (
  
    <React.Fragment>
      <EcommerceOrdersModal isOpen={modal1} toggle={toggleViewModal} />
      <LangModal
        isOpen={langModal}
        toggle={() => setLangModal(false)}
        sourceRecord={selectedItem}
        title="Medya / Galeri"
        tableName="Media_Lang"
        foreignKey="Media_ID"
        foreignKeyValue={selectedItem?.ID}
        fields={[
          { name: 'Media_ImageCover', label: 'Kapak Görseli', type: 'image' },
          { name: 'Media_Url', label: 'Dosya (PDF / Görsel)', type: 'file' },
          { name: 'Media_Tile', label: 'Başlık', type: 'text' },
        ]}
      />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteOrder}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Yönetim" breadcrumbItem="Galeri" />
          <PageHint
            what="PDF içerikler bu ekrandan yönetilir (medya ve kataloglar)."
            where="Kaydı eklerken “Kataloglar sayfasında görünsün” kutusunu işaretlerseniz Kataloglar sayfasında, işaretlemezseniz Medya sayfasında listelenir."
            note="Fotoğraf galerisi burası değil — onun için “Galeri (Fotoğraf)” ekranını kullanın."
            links={[{ label: 'Medya', path: '/medya' }, { label: 'Kataloglar', path: '/kataloglar' }]}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={orders}
                    isGlobalFilter={true}
                    isAddGallery={true}
                    handleOrderClicks={handleOrderClicks}
                    customPageSize={10}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle} tag="h4">
              {!!isEdit ? "Galeri Düzenle" : "Galeri Ekle"}
            </ModalHeader>
            <ModalBody>
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >

<div className="mb-3">
                      <Label className="form-label">Başlık</Label>
                      <Input
                        name="title"
                        type="text"
                        placeholder="Başlık"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.title || ""}
                        invalid={
                          validation.touched.title && validation.errors.title ? true : false
                        }
                      />
                      {validation.touched.title && validation.errors.title ? (
                        <FormFeedback type="invalid">{validation.errors.title}</FormFeedback>
                      ) : null}
                    </div>
                  
                 
                    <div className="mb-3">                  
                <Col xs={12} className="mb-3">
                            <label htmlFor="resume">Ana Görsel(800*600)</label>
                         <Dropzone
          getUploadParams={getUploadParams}
          onChangeStatus={handleChangeStatusMainPhoto}
          maxFiles={1}
          styles={{
            dropzone: { overflow: 'auto', border: '1px solid #999', background: '#f5f5f5' },
            inputLabelWithFiles: { margin: '20px 3%' }
          }}
          canRemove={false}
          PreviewComponent={Preview}
          accept="image/*"
        />
                
                          </Col>


                          {getFileNameMainPhoto != null ? 
                          <Row>
                                <label htmlFor="resume"> Mevcut Eklenen Resim</label>
                
                                <Col xs={12} className="mb-3">
                                            <img
                                  className=" avatar-xl"
                                  src={'https://buharasubdomain.stechomeyazilim.info/' +  getFileNameMainPhoto}
                                  alt=""
                                />
                                          </Col>
                                </Row> : null}
                
                   </div>

 

                   <div className="mb-3">
  <Col xs={12} className="mb-3">
    <label htmlFor="resume">Dosya Yükle (Görsel / PDF)</label>
    <Dropzone
      getUploadParams={getUploadParams}
      onChangeStatus={handleChangeExtraPhoto}
      maxFiles={1}
      styles={{
        dropzone: {
          overflow: 'auto',
          border: '1px solid #999',
          background: '#f5f5f5',
        },
        inputLabelWithFiles: { margin: '20px 3%' },
      }}
      canRemove={false}
      PreviewComponent={Preview}
      accept="image/*,application/pdf"
    />
  </Col>
</div>


{uploadedFiles?.filter(f => f.type === 'application/pdf').length > 0 && (
  <Col xs={12} className="mb-3">
    <label className="form-label">Yüklenen PDF Dosyaları</label>
    <ul className="list-group">
      {uploadedFiles
        .filter(file => file.type === 'application/pdf')
        .map((file, index) => (
          <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
            <span>{file.name}</span>
            <a
              href={'https://buharasubdomain.stechomeyazilim.info/' + file.url}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-sm btn-outline-primary"
            >
              Görüntüle
            </a>
          </li>
        ))}
    </ul>
  </Col>
)}
                
                  

                <div className="square-switch">
                            <input
                              type="checkbox"
                              id="square-switch1"
                              className="switch"
                              defaultChecked={getIsActive}
                              onChange={() =>
                                setIsActive(!getIsActive)
                              }
                            />
                            <label
                         htmlFor="square-switch1"
                              data-on-label="Aktif "
                              data-off-label="Pasif"
                            />
                          </div>

                {/* Medya mı katalog mu: iki sayfa aynı tabloyu kullandığı için
                    kaydın hangi sayfada görüneceği burada seçiliyor. */}
                <div className="form-check mt-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="media-is-catalog"
                    checked={getIsCatalog}
                    onChange={() => setIsCatalog(!getIsCatalog)}
                  />
                  <label className="form-check-label" htmlFor="media-is-catalog">
                    Bu kayıt <strong>Kataloglar</strong> sayfasında görünsün
                  </label>
                  <div>
                    <small className="text-muted">
                      İşaretlenmezse sitedeki <strong>Medya</strong> sayfasında listelenir.
                    </small>
                  </div>
                </div>

                <Row>
                  <Col>
                    <div className="text-end">
                      <button
                        type="submit"
                        className="btn btn-success save-user"
                      >
                        Kaydet
                      </button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>
        </div>
      </div>
  
    </React.Fragment>
  
  );
}
EcommerceOrder.propTypes = {
  preGlobalFilteredRows: PropTypes.any,

};


export default EcommerceOrder;